export default __webpack_public_path__ + "static/media/moderatorIcon.0d8b3835.svg";